<template>
  <span :title="JSON.stringify(ticket)">{{ticket.orderTitle}}</span>
</template>

<script>
export default {
    name : 'TicketTitleByNo',

    props : ['value'],

    data() {
        return {
            ticket : {}
        }
    },

    mounted() {
        var _this = this;
        sdk.TicketApi().findByOrderId({
            orderId : _this.value
        }).then(res => {
            if ( !res ) {
                console.log('#23 ticket not found by no', _this.value);
                return;
            }
            _this.ticket = res;
        });
    }
}
</script>


// WEBPACK FOOTER //
// src/components/ticket/TicketTitleByNo.vue